
// hold all changes
class Changes  {
    constructor(technicianCode, technicianName, parentObject) {
        this.technicianCode=technicianCode;
        this.technicianName=technicianName;
        this.state = this.GetInitialState();

        this.pictures = [];

        this.parentObject=parentObject;
    }

    GetInitialState() {
        return  {
            iban: null,
            changedCustomer:null,
            changedContactPersons:[],
            keySafeCode:null,
            equipmentRemoved: [],
            equipmentAdded: [],
            equipmentModified: [],
            pstnInstalled: null,
            PstnCustomerInformed: null,
            mbcode1:null,
            mbcode2:null,
            emergencyCenter:null,
            resolution: null,
            testStart: null,
            testSeconds: null,
            accessories: {},
            productsAdded: null,
            productsRemoved: null,
            linetest: null,
            alarmcall: null,
            validdata: null,
            timeStart: new Date(),
            signature: null,
            processRemark: null,
            createNewServiceCall: false,
            cancelServiceCall: false,
            activities: [],
            confirmedNoPaceMaker:false,
            technicianCode: this.technicianCode,
            technicianName: this.technicianName
        }
    }

    HasChanges() {
        const hasChanges=this.state.equipmentAdded.length > 0 ||
            this.state.equipmentModified.length > 0 ||
            this.state.equipmentRemoved.length > 0 ||
            Object.keys(this.state.accessories).length > 0 ||
            this.state.resolution!==null ||
            this.state.productsAdded ||
            this.state.productsRemoved ||
            this.state.processRemark !== null ||
            this.state.activities.length > 0 ||
            this.pictures.length > 0 ||
            this.state.changedCustomer ||
            this.state.changedContactPersons.length>0
        return hasChanges;
    }


    Reset() {
        this.state=this.GetInitialState();
    }

    UpdateParentObject() {
        this.parentObject.setState({hasChanges: this.HasChanges(), cancelServiceCall: this.state.cancelServiceCall});
    }

    SetIban(value) {
        this.state.iban=value;
        this.UpdateParentObject();
    }

    SetKeySafeCode (value) {
        this.state.keySafeCode=value;
        this.UpdateParentObject();
    }

    SetActivities(newActivities) {
        if (!this.state.activities) this.state.activities = [];
        this.state.activities = newActivities;
        this.UpdateParentObject();
    }

    AddEquipment(newItem) {
        this.state.equipmentAdded.push(newItem);
        this.state.signature = null;            // reset the signature (customer needs to reconfirm)
        this.UpdateParentObject();
    }

    ChangeAddedEquipment(kek, status) {
        const item= this.state.equipmentAdded.find(p=> p.number===kek);
        if (item) {
            item.status=status;
        }
    }
    ModifyEquipmentCode(kek, value) {
        // lookup the equipment in "added"
        var item=this.state.equipmentAdded.find(p=>p.number===kek);
        if (item) {
            item.keySafeCode=value;
            return;
        }
        item=this.state.equipmentModified.find(p=>p.number===kek);
        if (item) {
            item.keySafeCode=value;
            return;
        }
        this.state.equipmentModified.push({
            number:kek,
            keySafeCode:value
        });
    }
    ModifyEquipmentWorkInformation(kek, value) {
        // lookup the equipment in "added"
        var item=this.state.equipmentAdded.find(p=>p.number===kek);
        if (item) {
            item.workInformation=value;
            return;
        }
        item=this.state.equipmentModified.find(p=>p.number===kek);
        if (item) {
            item.workInformation=value;
            return;
        }
        this.state.equipmentModified.push({
            number:kek,
            workInformation:value
        });
    }
    RemoveEquipment(item) {
        this.state.equipmentRemoved.push(item);
        this.state.signature = null;        // reset the signature (customer needs to resign)
        this.UpdateParentObject();
    }
    SetAccessory(name, value) {
        this.state.accessories[name] = value;  // save to the parent object
        this.state.signature = null;
        this.UpdateParentObject();
    }
    AddProduct(item) {
        if (!this.state.productsAdded) this.state.productsAdded = [];
        this.state.productsAdded.push(item);
        this.state.signature = null;
        this.UpdateParentObject();
    }
    RemoveProduct(item) {
        if (!this.state.productsRemoved) this.state.productsRemoved = [];
        if (item.id) {
            // this was an item originally on the order, it must be removed
            this.state.productsRemoved.push(item);
        } else {
            // this item was probably already added before, but is not already on the order, so just remove the first ocurrence
            var idx=this.state.productsAdded.findIndex(p=>p.item.code===item.item.code);
            if (idx!==-1)  this.state.productsAdded.splice(idx,1);
        }
        this.state.signature = null;
        this.UpdateParentObject();
    }
    ResetProducts() {
        this.state.productsAdded=null;
        this.state.productsRemoved=null;
    }
    Set (name,value) {
        this.state[name]=value;
        this.UpdateParentObject();
    }
    AddPicture(newItem) {
        this.pictures.push(newItem);
        this.UpdateParentObject();
    }
    SetCustomer(bp) { 
        // change the customer details (name, address, contact information)
        this.state.changedCustomer=bp;
        this.UpdateParentObject();
    }
    SetContactPerson(contact) { 
        // change a contact person
        var idx=this.state.changedContactPersons.findIndex(p=>p.internalCode===contact.internalCode);
        if (idx===-1) {
            // add a changed contact
            this.state.changedContactPersons.push(contact);
        } else {
            // update an already changed contact 
            this.state.changedContactPersons[idx]=contact;
        }
        this.UpdateParentObject();
    }
    RemoveContactPerson(internalCode) {
        var idx=this.state.changedContactPersons.findIndex(p=>p.internalCode===internalCode);
        if (idx===-1) {
            // add a "removed" contact
            this.state.changedContactPersons.push({
                internalCode : internalCode,
                active:false,
                name: {},
                address: {},
                contact:{}
             });
        } else {
            // update an already changed contact 
            this.state.changedContactPersons[idx].active=false;
        }
        this.UpdateParentObject();
    }
    ResetProductsEnabled() {
        return this.state.productsAdded !== null || this.state.productsRemoved !== null
    }
    AddActivityNote(title, details) {
        var item = { assignedTo: { id: 151 }, action: "N", activityType: { code: -1 }, name: "Helpdesk", details: title, notes: details };
        this.state.activities = [...this.state.activities, item]
    }
    AddActivityHelpdesk(notes) {
        var item = { assignedTo: { id: 151 }, action: "T", activityType: { code: 33 }, priority: "H", name: "Helpdesk", details: "Opmerking vanuit Digibon", notes: notes };
        this.state.activities = [...this.state.activities, item]
    }
    AppendResolution(text) {
        if (this.state.resolution==="" || this.state.resolution===null) {
            this.state.resolution=text;
        } else {
            this.state.resolution=this.state.resolution + "\r\n" + text;
        }
    }


}

export default Changes;